import { render, staticRenderFns } from "./admin_order_alarm_log.vue?vue&type=template&id=73a48cb4"
import script from "./admin_order_alarm_log.vue?vue&type=script&lang=js"
export * from "./admin_order_alarm_log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports